import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import MenuHorizontal from "../../layouts/MenuHorizontal";
import {
  Container,
  Grid,
  Icon,
  Divider,
  Button,
  Transition,
} from "semantic-ui-react";
import { find } from "../../../actions/categoria";
import { Rodape } from "../../layouts/Rodape";
import Categoria from "./Categoria";

class Categorias extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      errors: {},
    };
  }

  componentDidMount = async () => {
    await this.props.find();
    this.setState({ loading: false });
  };

  render() {
    const { categorias } = this.props;
    return (
      <div>
        <MenuHorizontal />
        <Container style={{ paddingTop: "10px" }}>
          <div style={{ textAlign: "center", marginBottom: "35px" }}>
            <Button
              className="ui-btn-1"
              as={Link}
              to={"/dashboard/categorias/cadastrar"}
            >
              <Icon name="plus" /> Adicionar Categoria
            </Button>
            <Transition>
              <div>
                <div className="ui-div-msg">
                  <br />
                </div>
                <Link to="/dashboard" size="small">
                  Voltar
                </Link>
              </div>
            </Transition>
          </div>
          <Divider horizontal>Categorias</Divider>
          <Grid columns={4} doubling stackable style={{ marginTop: "20px" }}>
            {!!categorias.length &&
              categorias.map((categoria) => (
                <Grid.Column key={categoria._id}>
                  <Categoria categoria={categoria} />
                </Grid.Column>
              ))}
          </Grid>
        </Container>
        <Rodape />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    categorias: state.categoria.categorias,
    quantidade: state.categoria.quantidade,
    errors: state.categoria.errors,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      find,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Categorias);
